import React from "react";
import { Button, Stack } from "@mui/material";

import PopupMarkdown from "./PopupMarkdown";
import PopupShell from "./PopupShell";
import { useNavigate } from 'react-router-dom';

/**
 * InfoPopup
 */
const InfoPopup = ({ open, onClose, popupData }) => {
    const { title, msg, action } = popupData || {};
    const navigate = useNavigate();

    const handleOk = () => {
        onClose?.();
        if(action != "" && action != undefined) navigate(action);
    };

    return (
        <PopupShell
            open={open}
            onClose={onClose}
            title={title}
            // Use Stack for button alignment and spacing
            footer={
                <Stack
                    direction="row"
                    spacing={2}
                    width="100%"
                    justifyContent="flex-end"
                >
                    {/* Cancel Button - Styled based on the image_0.png */}
                    <Button
                        variant="text"
                        color="inherit"
                        onClick={onClose}
                        sx={{
                            textTransform: "none",
                            fontWeight: 500, // Medium weight as in the image
                            fontSize: "0.875rem", // Standard size
                            color: "#888888", // Grey color as in image_0.png
                            padding: "8px 24px",
                            // No need to manually style hover/active/focus for variant="text",
                            // MUI handles this gracefully in dark themes.
                        }}
                    >
                        Close
                    </Button>

                    {/* Ok Button (acts like 'Publish Now' but is 'Ok' for this type) */}
                    <Button
                        variant="contained"
                        onClick={handleOk}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "0.875rem",
                            padding: "8px 24px",
                            borderRadius: "6px",
                            backgroundColor: "#3f8cff",
                            color: "#ffffff",
                            "&:hover": {
                                backgroundColor: "#2f78e0",
                            },
                        }}
                    >
                        Ok
                    </Button>
                </Stack>
            }
        >
            <PopupMarkdown content={msg} />
        </PopupShell>
    );
};

export default InfoPopup;
